import { forwardRef, useState } from 'react'
import { useSnackbar } from "notistack"
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Slide from '@material-ui/core/Slide'
import { CircularProgress, Grid, Checkbox } from '@material-ui/core'
import { useEffect } from 'react'
import { DadosReciboAceite } from './styles'
import PDFView from "../../../components/lab/PdfView"
import ComunicacaoControleService from "../../../services/ComunicacaoControleService"
import webconfig from "../../../webconfig.json"

const Transition = forwardRef(function Transition(props, ref) {
  return <Slide direction="up" ref={ref} {...props} />
})

export default function ReciboAceite({
  idOrgaoJurisdicionado,
  recibo,
  setRecibo,
  setRecarregarComunicacoes }) {

  const { enqueueSnackbar } = useSnackbar()
  const [loading, setLoading] = useState(false)
  const [checked, setChecked] = useState(false)

  const handleChange = (event) => {
    setChecked(event.target.checked)
  }

  const assinar = () => {
    setLoading(true);
    ComunicacaoControleService.Assina(recibo.controle.id, idOrgaoJurisdicionado)
      .then(response => {
        setLoading(false)
        if (response.status === 200) {
          enqueueSnackbar(response.data, { variant: 'success', autoHideDuration: webconfig.snackbarAutoHideDuration })
        }
        else {
          enqueueSnackbar('Não foi possível assinar o Recibo de Aceite. Contate o suporte.', { variant: 'error', autoHideDuration: webconfig.snackbarAutoHideDuration })
        }

        let dataAtual = new Date();

        setRecarregarComunicacoes(dataAtual.toString())
        handleFecharRecibo()
      })
      .catch(error => {
        setLoading(false)
        if (error.response && error.response.data) {
          if (error.response.status === 422) {
            try {
              const validacao = JSON.parse(error.response.data.detail);
              let mensagem = "Não foi possível realizar a operação devido a(s) seguinte(s) validação(ões): ";
              for (let i = 0; i < validacao.Validacoes.length; i++) {

                var itemValidado = validacao.Validacoes[i];
                for (var propriedadeValidada in itemValidado) {
                  mensagem += itemValidado[propriedadeValidada];
                }

                if ((i + 1) < validacao.Validacoes.length) {
                  mensagem += "; ";
                }
              }

              enqueueSnackbar(`${mensagem}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
            }
            catch (e) {
              if (error.response.data.detail) {
                enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
              }
            }
          }
          else if (error.response.status === 500) {
            enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.response.data.detail})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
          }
          else {
            enqueueSnackbar(`${error.response.data.detail}`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
          }
        }
        else {
          enqueueSnackbar(`Ocorreu um erro inesperado. Contate o suporte (${error.message})`, { variant: "error", autoHideDuration: webconfig.snackbarAutoHideDuration })
        }
      })
  }

  const handleFecharRecibo = () => {
    setChecked(false);
    setRecibo({
      open: false,
      controle: {}
    })
    if (!loading) {
      setRecibo({
        open: false,
        controle: {}
      })
    }
  }

  useEffect(() => {
  }, [recibo.open])

  return (
    <Dialog
      open={recibo.open}
      TransitionComponent={Transition}
      keepMounted
      onClose={handleFecharRecibo}
      aria-labelledby="alert-dialog-slide-title"
      aria-describedby="alert-dialog-slide-description"
      id="dialog-padrao"
    >
      <DialogTitle id="alert-dialog-slide-title" className="txt-primario">Recibo de Entrega</DialogTitle>
      <DialogContent>
        <Grid container spacing={2}>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>

            <DadosReciboAceite.PdfPreview id="DadosReciboAceite_PdfPreview">
              <PDFView
                url={recibo.conteudoReciboBase64}
                nameFile={`${recibo.controle.numeroDocumentoNaOrigem} - ${recibo.controle.dataCriacao}.pdf`}
              />
            </DadosReciboAceite.PdfPreview>

          </Grid>

        </Grid>
      </DialogContent>
      <DialogActions>
        <Grid container spacing={2}>
          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            <p>
              <Checkbox
                checked={checked}
                onChange={handleChange}
                className="txt-primario"
                inputProps={{ 'aria-label': 'primary checkbox' }}
                disabled={loading}
              />
              <b>
                Li, compreendi e aceito as condições constantes no <a href='https://gnoi.tce.go.gov.br/atoNormativo/Publicado?id=23748' target='_blank' rel="noreferrer">Resolução Normativa 10/2024 do TCE-GO</a>,
                por isso aceito e assino o recibo gerado eletronicamente ao clicar em Confirmar.
              </b>
            </p>
          </Grid>

          <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
            {checked && (
              <Button
                className="bg-primario txt-branco btn-salvar-default"
                onClick={() => loading ? ('') : assinar()}
                style={{ float: "inline-end" }}>
                {
                  loading
                    ?
                    <CircularProgress size={22} />
                    :
                    'Confirmar'
                }
              </Button>
            )}

            <Button
              onClick={handleFecharRecibo}
              className="bg-alternativo-4 txt-alternativo-3"
              disabled={loading}
              style={{ float: "inline-end" }}>
              Cancelar
            </Button>
          </Grid>
        </Grid>

      </DialogActions>
    </Dialog>
  )
}